<template>
  <div id="yagiprimehelp" class="parallax">
    <div class="yagiprimehelp">
      <!--MV-->
      <section class="flex mv">
        <div class="renew2_wrapper mv-wrap">
          <div class="mv-top">
            <img src="/static/renew3_img/yagiprime_lp20250220/mv01.png" alt="爆速就活" class="mv01">
          </div>
          <div class="deco deco01"></div>
          <div class="cv-box">
            <a href="#point" class="cv-btn cv-btn--mv">まずは気になる機能をチェック</a>
          </div>
          <div class="deco deco02"></div>
        </div>

        <!--サイドメニュー-->
        <div class="pc sidemenu" ref="fixedElement"
          :class="{ 'sidemenu--is-hidden': !isFixedElementVisible, 'sidemenu--display': isFixedElementVisible }">
          <h3 class="pointh3">
            <img src="/static/renew3_img/yagiprime_lp20250220/titlepointlot.png" alt="目次" class="pointh3img">
          </h3>
          <ul class="sidemenu__list">
            <li class="sidemenu-item">
              <a href="#index05" class="sidemenulink">POINT0 エージェント</a>
            </li>
            <li class="sidemenu-item">
              <a href="#index01" class="sidemenulink">POINT1 証明写真風</a>
            </li>
            <li class="sidemenu-item">
              <a href="#index02" class="sidemenulink">POINT2 文章生成</a>
            </li>
            <li class="sidemenu-item">
              <a href="#index01" class="sidemenulink">POINT3 面接練習</a>
            </li>
            <li class="sidemenu-item">
              <a href="#index04" class="sidemenulink">機能一覧を見る</a>
            </li>
            <li class="sidemenu-item">
              <a @click="showYagiprimePaymentDialog" class="cv-btn" style="cursor: pointer">{{ $globalVar.isYagiPrime ?
                'マイページで確認する' : 'ヤギプライムに入る' }}</a>
            </li>
          </ul>
        </div>
      </section>

      <!--ストーリー-->
      <section class="fifth">
        <div class="renew2_wrapper fifth-wrap">
          <h3 class="pointh3">
            <img src="/static/renew3_img/yagiprime_lp20250220/titlepoint05.png" alt="こんなお悩みありませんか" class="pointimg">
          </h3>

          <img src="/static/renew3_img/yagiprime_lp20250220/storyimg.png" alt="諦めちゃうヤギ" class="storyimg">

          <h3 class="pointh3">
            <img src="/static/renew3_img/yagiprime_lp20250220/titlepoint06.png" alt="こんな人におすすめ" class="pointimg">
          </h3>
        </div>
      </section>

      <!--ポイント-->
      <section class="second">
        <ul class="second-list">
          <li id="index05" class="second-list__item second-list__item--bk02">
            <h3 class="pointh3">
              <img src="/static/renew3_img/yagiprime_lp20250220/point00.png" alt="point00" class="pointimg">
              <img src="/static/renew3_img/yagiprime_lp20250220/titlepoint04.png" alt="リアルエージェント" class="pointh3img">
            </h3>

            <!--<ul class="subpoint-list">
              <li class="subpoint-item">yagish提携の信頼できる<br>いつでも気軽に面接練習できる</li>
            </ul>-->

            <!--<div class="imgblock imgblock--agent">
              <img src="/static/renew3_img/yagiprime_lp20250220/pointbgimg06.png" alt="yagish提携の信頼できるいつでも気軽に面接練習できる"
                class="pointbgimg pointbgimg">
            </div>-->

            <a @click="showYagiprimePaymentDialog" class="cv-btn" style="cursor: pointer">{{ $globalVar.isYagiPrime ?
              'マイページで確認する' : '紹介会社に相談する' }}</a>

            <a v-if="!$globalVar.isYagiPrime" @click="showYagiprimePaymentDialog" class="cv-btn cv-btn--sub"
              style="cursor: pointer">今すぐヤギプラで就活</a>

          </li>

          <li id="index01" class="second-list__item second-list__item--bk01">

            <h3 class="pointh3">
              <img src="/static/renew3_img/yagiprime_lp20250220/point01.png" alt="point03" class="pointimg">
              <img src="/static/renew3_img/yagiprime_lp20250220/titlepoint01.png" alt="証明写真風で手間いらず" class="pointh3img">
            </h3>

            <ul class="subpoint-list">
              <li class="subpoint-item">証明写真アプリを<br>別途インストールする必要なし</li>
              <li class="subpoint-item">アップロード回数に制限なし！<br>何度も変更できる</li>
            </ul>

            <div class="imgblock">
              <img src="/static/renew3_img/yagiprime_lp20250220/pointbgimg01.png" alt="ヤギは個性を出した履歴書が人気だメェ〜"
                class="pointbgimg">
              <img src="/static/renew3_img/yagiprime_lp20250220/yagiword01.png" alt="ヤギは個性を出した履歴書が人気だメェ〜"
                class="yagiword">
            </div>

            <p class="point-txt">
              履歴書作成中の「証明写真をアップロード」のステップで、ヤギプライム会員は証明写真風に写真を自動加工することができます。スマホでもパソコンでも、写真をアップロードして「使う」だけ！
            </p>

            <a href="/format/rirekisho_job_change/edit/id-photo" target="_blank" class="cv-btn">証明写真風の機能を使ってみる</a>

            <a v-if="!$globalVar.isYagiPrime" @click="showYagiprimePaymentDialog" class="cv-btn cv-btn--sub"
              style="cursor: pointer">ヤギプラで全ての機能を使う</a>

          </li>

          <li id="index02" class="second-list__item second-list__item--bk02">
            <h3 class="pointh3 pointhgr3">
              <img src="/static/renew3_img/yagiprime_lp20250220/point02.png" alt="point02"
                class="pointimg pointimg--txt">
              <img src="/static/renew3_img/yagiprime_lp20250220/titlepoint02.png" alt="AIを使って文章は一瞬" class="pointh3img">
            </h3>

            <ul class="subpoint-list">
              <li class="subpoint-item subpoint-gritem">自分の経歴に沿って、<br>AIが自動で文章を作成する</li>
              <li class="subpoint-item subpoint-gritem">4つの質問に答えたら、<br>もっとあなたらしい文章に！</li>
            </ul>

            <div class="imgblock">
              <img src="/static/renew3_img/yagiprime_lp20250220/pointbgimg02.png" alt="ヤギはAIを作る側なんだメ！すごい？"
                class="pointbgimg">
              <img src="/static/renew3_img/yagiprime_lp20250220/yagiword02.png" alt="ヤギはAIを作る側なんだメ！すごい？"
                class="yagiword">
            </div>

            <p class="point-txt">
              履歴書の「志望動機」「自己PR」、職務経歴書の「職務経歴」「自己PR」を自動で作成することができます。長い職歴がある方は特におすすめの機能です！
              <br>※1日5回までのご利用になります。
            </p>

            <a href="/format/rirekisho_job_change/edit/reason" target="_blank" class="cv-btn">履歴書の志望動機で見てみる</a>

            <a v-if="!$globalVar.isYagiPrime" @click="showYagiprimePaymentDialog" class="cv-btn cv-btn--sub"
              style="cursor: pointer">ヤギプラでサクッと就活</a>

          </li>

          <li id="index01" class="second-list__item second-list__item--bk01">
            <h3 class="pointh3">
              <img src="/static/renew3_img/yagiprime_lp20250220/point03.png" alt="point03"
                class="pointimg pointimg--txt">
              <img src="/static/renew3_img/yagiprime_lp20250220/titlepoint03.png" alt="AIヤギは意外と熱血面接官"
                class="pointh3img">
            </h3>

            <ul class="subpoint-list">
              <li class="subpoint-item">テキストメッセージで<br>いつでも気軽に面接練習できる</li>
              <li class="subpoint-item">面接練習の内容は振り返り可、<br>何度でもAIヤギからアドバイス</li>
            </ul>

            <div class="imgblock">
              <img src="/static/renew3_img/yagiprime_lp20250220/pointbgimg03.png" alt="もしかしたらお悩みだって聞くかもよ…？"
                class="pointbgimg">
              <img src="/static/renew3_img/yagiprime_lp20250220/yagiword03.png" alt="もしかしたらお悩みだって聞くかもよ…？"
                class="yagiword">
            </div>

            <p class="point-txt">
              テキストベースなので、電車の中でも気軽に面接練習の受け答えができます。何度も繰り返して練習できるので、面接対策バッチリ！<br>※音声でのやり取りはリリースされました！</p>
            <a href="/ai/interview_practice" target="_blank" class="cv-btn">AI面接練習を試してみる</a>

            <a v-if="!$globalVar.isYagiPrime" @click="showYagiprimePaymentDialog" class="cv-btn cv-btn--sub"
              style="cursor: pointer">今すぐヤギプラで就活</a>

          </li>

          <li id="index04" class="second-list__item second-list__item--bk02">
            <h3 class="pointh3 pointhgr3 pointloth3">
              <img src="/static/renew3_img/yagiprime_lp20250220/pointlot.png" alt="pointlot" class="pointimg">
              <img src="/static/renew3_img/yagiprime_lp20250220/titlepointlot.png" alt="使いたい機能もりもり" class="pointh3img">
            </h3>

            <p class="pointlot_lead">履歴書を作ることに特化した<br>ヤギッシュだからできるサービスです</p>

            <ul class="servicelist">
              <li class="serviceitem"><img src="/static/renew3_img/yagiprime_lp20250220/service01.png" alt="AI志望動機"
                  class="serviceimg"></li>
              <li class="serviceitem"><img src="/static/renew3_img/yagiprime_lp20250220/service02.png" alt="AI自己PR"
                  class="serviceimg"></li>
              <li class="serviceitem"><img src="/static/renew3_img/yagiprime_lp20250220/service03.png" alt="AI面接練習"
                  class="serviceimg"></li>
              <li class="serviceitem"><img src="/static/renew3_img/yagiprime_lp20250220/service04.png" alt="お仕事レコメンド"
                  class="serviceimg"></li>
              <li class="serviceitem"><img src="/static/renew3_img/yagiprime_lp20250220/service05.png" alt="エージェント対応"
                  class="serviceimg"></li>
              <li class="serviceitem"><img src="/static/renew3_img/yagiprime_lp20250220/service06.png" alt="メール便無料"
                  class="serviceimg"></li>
              <li class="serviceitem"><img src="/static/renew3_img/yagiprime_lp20250220/service07.png" alt="フォント切り替え"
                  class="serviceimg"></li>
              <li class="serviceitem"><img src="/static/renew3_img/yagiprime_lp20250220/service08.png" alt="証明写真風加工"
                  class="serviceimg"></li>
              <li class="serviceitem"></li>
            </ul>

            <div class="imgblock">
              <img src="/static/renew3_img/yagiprime_lp20250220/pointbgimg04.png" alt="気になるサービスはあった？使ってみよー"
                class="pointbgimg pointlotbgimg">
              <img src="/static/renew3_img/yagiprime_lp20250220/yagiwordlot.png" alt="気になるサービスはあった？使ってみよー"
                class="yagiword">
            </div>

            <a @click="showYagiprimePaymentDialog" class="cv-btn" style="cursor: pointer">{{ $globalVar.isYagiPrime ?
              'マイページで確認する' : 'ヤギプラで内定への一歩を！' }}</a>

          </li>
        </ul>
      </section>

      <!--まとめ-->
      <section class="renew2_wrapper third">
        <h3 class="thirdh3">
          <img src="/static/renew3_img/yagiprime_lp20250220/thirdh3.png" alt="ヤギプラってタイパ良すぎ" class="pointh3img">
        </h3>

        <img src="/static/renew3_img/yagiprime_lp20250220/pointbgimg05.png" alt="ヤギプラってタイパ良すぎ" class="third_img">

        <p class="third_lead">履歴書作成の「ちょっと面倒だな」を<br>トータルに解決します！</p>

        <p class="third_txt">
          ヤギプライムは、あなたの就職・転職活動を成功に導くための、AI搭載型オールインワンサポートサービスです。<br><br>
          AIがあなたの転職活動を劇的にサポート！ヤギプライムは、履歴書作成から面接までAIが徹底サポートする、あなたのためのパートナーです。煩わしい書類作成も一瞬で完了。自己分析、適性検査、面接対策までAIヤギがチャットで伴走。効率と質を爆上げし、理想のキャリアを掴みませんか？
        </p>

        <a @click="showYagiprimePaymentDialog" class="cv-btn" style="cursor: pointer">{{ $globalVar.isYagiPrime ?
          'マイページで確認する' : 'ヤギプライムで効率的に就活' }}</a>
        <p class="third_memo" v-if="!$globalVar.isYagiPrime">いつでもキャンセル可能</p>

        <!--就活応援プラン-->
        <div class="studentplan">
          <h3 class="thirdh3">
            <img src="/static/renew3_img/yagiprime_lp20250220/h3_studentplan.png" alt="実は学生はお得" class="pointh3img">
          </h3>
          <ul class="subpoint-list">
            <li class="subpoint-item"><span>言語・非言語問題対策</span><br>問題解き放題！</li>
            <li class="subpoint-item"><span>自己分析</span>をAIヤギと一緒に<br>サクッとできる！</li>
            <li class="subpoint-item">就活応援プランは<span>追加料金なし</span>で、<br>問題集・自己分析使い放題</li>
          </ul>
          <p class="point-txt">
            チャット形式で対策可能！就活の期間次第では問題集を買うよりお得かも！？自己分析は、自分を表す単語やエピソードをAIヤギと一緒に深掘りしていくことで自分の「できること」「やりたいこと」が見えること間違いなし！
          </p>
          <p>※就活応援プランは新卒系の履歴書テンプレートを利用しているユーザーに限ります。</p>

          <img src="/static/renew3_img/yagiprime_lp20250220/tableaddimg.png" alt="問題集・自己分析使い放題" class="tableaddimg">
        </div>

        <table class="forth-table">
          <tr>
            <td class="f-table01"></td>
            <td class="f-table02">一般会員</td>
            <td class="f-table03">ヤギプライム<br>会員</td>
          </tr>
          <tr>
            <td class="f-table01">ヤギのメール便</td>
            <td class="f-table02">330円／1回</td>
            <td class="f-table03">使い放題</td>
          </tr>
          <tr>
            <td class="f-table01">フォント機能</td>
            <td class="f-table02">なし</td>
            <td class="f-table03">使い放題</td>
          </tr>
          <tr v-if="false">
            <td class="f-table01">AI文章作成</td>
            <td class="f-table02">1回無料</td>
            <td class="f-table03">5回まで／1日</td>
          </tr>
          <tr>
            <td class="f-table01">AI面接練習</td>
            <td class="f-table02">なし</td>
            <td class="f-table03">練習し放題</td>
          </tr>
          <tr>
            <td class="f-table01">証明写真風加工</td>
            <td class="f-table02">なし</td>
            <td class="f-table03">何度でも可</td>
          </tr>
          <tr>
            <td class="f-table01">お仕事<br>レコメンド</td>
            <td class="f-table02">キーワードで<br>レコメンド</td>
            <td class="f-table03">AIが<br>レコメンド</td>
          </tr>
          <tr>
            <td class="f-table01">エージェント</td>
            <td class="f-table02">なし</td>
            <td class="f-table03">情報提供あり</td>
          </tr>
          <tr>
            <td class="f-table01">サブスク<br>料金</td>
            <td class="f-table02">無料</td>
            <td class="f-table03">30日間550円</td>
          </tr>
        </table>

        <img src="/static/renew3_img/yagiprime_lp20250220/thirdpositiveimg.png" alt="ストレス軽減！" class="cv-img">

        <a @click="showYagiprimePaymentDialog" class="cv-btn" style="cursor: pointer">{{ $globalVar.isYagiPrime ?
          'マイページで確認する' : 'ヤギと一緒なら大丈夫だメェ〜' }}</a>
        <p class="third_memo" v-if="!$globalVar.isYagiPrime">いつでもキャンセル可能</p>
      </section>

      <!--よくある質問-->
      <section class="renew2_wrapper forth" ref="footerElement">
        <h3 class="thirdh3">
          <img src="/static/renew3_img/yagiprime_lp20250220/titlepointfaq.png" alt="よくある質問" class="pointh3img">
        </h3>

        <ul class="forth-faq">
          <li class="forth-faq__list">
            <p class="question">ヤギプライムとはなんですか？</p>
            <p class="answer">ヤギプライムは、仕事探しをするすべての人を応援する、便利機能がいっぱいつまったお得なサブスクリプションサービスです。詳しくはこちらをご確認ください。</p>
          </li>
          <li class="forth-faq__list">
            <p class="question">ヤギプライムの利用料金を教えてください。</p>
            <p class="answer">30日間ごとに550円(税込)となります。初回のサービス提供期間終了後、自動更新され、以降30日ごとに550円（税込）がかかります。</p>
          </li>
          <li class="forth-faq__list">
            <p class="question">利用料金の支払い方法は何がありますか？</p>
            <p class="answer">クレジットカードとPayPayがご利用いただけます。</p>
          </li>
          <li class="forth-faq__list">
            <p class="question">仕事が決まると追加料金は発生しますか？</p>
            <p class="answer">ヤギプライムでは就職や転職、アルバイトで採用が決まっても、追加料金は発生しません。</p>
          </li>
          <li class="forth-faq__list">
            <p class="question">転職が終了したり、不要になったりしたので、ヤギプライムを解約したいです。</p>
            <p class="answer"><a href="/yagiprimecancel" class="a-link">こちら</a>から解約することができます。</p>
          </li>
        </ul>

        <a @click="showYagiprimePaymentDialog" class="cv-btn" style="cursor: pointer">{{ $globalVar.isYagiPrime ?
          'マイページで確認する' : 'ヤギプラで内定への一歩を！' }}</a>
      </section>
    </div>

    <login-dialog />
    <yagiprime-payment-dialog />
  </div>

</template>

<script>
import YagiprimePaymentDialog from '@/components/yagiprime/YagiprimePaymentDialog'
import LoginDialog from '../../components/LoginDialog.vue'

export default {
  components: {
    YagiprimePaymentDialog,
    LoginDialog
  },
  data() {
    return {
      isFixedElementVisible: true,
    };
  },
  created() {
    // サービスの初期化とイベントリスナーの登録
    this.$yagiprimePaymentService.init(this)
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll);
  },
  beforeDestroy() {
    // コンポーネントが破棄される前に、必ずイベントリスナーを削除する
    window.removeEventListener('scroll', this.handleScroll);
  },
  destroyed() {
    // サービスのクリーンアップ
    this.$yagiprimePaymentService.cleanup(this)
  },
  methods: {
    showYagiprimePaymentDialog() {
      // useFeatureを使ってログインチェックを含めた課金フローを開始
      this.$yagiprimePaymentService.useFeature(this, 'yagiprime-lp', {
        onSuccess: () => {
          this.$router.push('/mypage/yagiprime')
        },
        onCancel: () => {
          console.log('ヤギプライム会員登録がキャンセルされました')
        }
      })

      // フッターが画面内に表示されている場合のスクロール調整
      const footer = document.querySelector('footer') || document.querySelector('.footer') || document.getElementById('footer')
      if (footer) {
        const footerRect = footer.getBoundingClientRect()
        const windowHeight = window.innerHeight
        if (footerRect.top < windowHeight) {
          const scrollAmount = footerRect.top - windowHeight
          window.scrollBy({
            top: scrollAmount,
            behavior: 'smooth'
          })
        }
      }
    },
    // スクロールされるたびに実行されるメソッド
    handleScroll() {
      // refを使ってフッター要素を取得
      const footer = this.$refs.footerElement;
      // 要素がまだ存在しない場合は何もしない
      if (!footer) return;

      // getBoundingClientRect() で要素のサイズとビューポートに対する相対位置を取得
      const rect = footer.getBoundingClientRect();

      // ウィンドウ（ビューポート）の高さを取得
      const windowHeight = window.innerHeight;

      // ★判定ロジック
      // フッターの上端が、ウィンドウの高さより小さい位置に来た
      // = フッターが見え始めたということ
      if (rect.top < windowHeight) {
        // フッターが見えたら、追従要素を非表示
        this.isFixedElementVisible = false;
      } else {
        // フッターがまだ見えていなければ、追従要素を表示
        this.isFixedElementVisible = true;
      }
    }
  }
}
</script>
<style lang="scss" scoped>
@import '@/assets/scss/variables.scss';

/*共通*/
.yagiprimehelp {
  width: 360px;
  margin: 0 auto;
  background: #ffffff;

  @include max-width(sm) {
    width: 100%;
  }

  a:hover {
    text-decoration: none;
    opacity: 1;
  }
}

.renew2_wrapper {
  padding: 0 20px;
}

.cv-btn {
  position: relative;
  display: block;
  width: 300px;
  padding: 15px 10px;
  margin: 0 auto;
  text-align: center;
  background: #E95B10;
  border-radius: 40px;
  border: 2px solid #E95B10;
  color: #ffffff;
  font-weight: bold;

  &--mv {
    background: #8FBD67;
    border: 2px solid #8FBD67;
  }


  &--sub {
    margin-top: 15px;
    background: #8FBD67;
    border: 2px solid #8FBD67;
  }

  &::before {
    content: "";
    width: 13px;
    height: 13px;
    border: 0;
    border-top: 2px solid #fff;
    border-right: 2px solid #fff;
    -webkit-transform: rotate(45deg);
    transform: rotate(45deg);
    position: absolute;
    top: 0;
    right: 20px;
    bottom: 0;
    margin: auto;
  }

  &:hover {
    border: 2px solid #E95B10;
    background: #fff;
    color: #E95B10;

    &::before {
      border-top: 2px solid #E95B10;
      border-right: 2px solid #E95B10;
    }
  }
}

.deco {
  position: relative;

  &::after {
    position: absolute;
    content: "";
  }
}

//パララックス
.parallax {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  clip-path: inset(0);

  &::after {
    content: '';
    position: fixed;
    top: 0;
    left: 0;
    z-index: -10;
    width: 100%;
    height: 100%;
    background-image: url(/static/renew3_img/yagiprime_lp20250220/back.png);
    background-size: cover;
    background-position: center;
    opacity: 0.6;
  }
}

//MV
.mv {
  position: relative;
  background: #E95B10;
  padding-top: 20px;
  padding-bottom: 50px;
  width: 360px;

  @include max-width(sm) {
    width: 100%;
  }

  .mv-wrap {
    width: 360px;

    @include max-width(sm) {
      width: 100%;
    }
  }

  .mv01 {
    margin-bottom: 15px;
  }

  .deco01 {
    &::after {
      background: url(/static/renew3_img/yagiprime_lp20250220/deco01.png) no-repeat;
      background-position: center;
      background-size: contain;
      width: 80px;
      height: 80px;
      right: 20px;
      bottom: -10px;
    }
  }

  .cv-btn {
    &::before {
      transform: rotate(135deg);
      bottom: 5px;
    }
  }

  .deco02 {
    &::after {
      background: url(/static/renew3_img/yagiprime_lp20250220/deco02.png) no-repeat;
      background-position: center;
      background-size: contain;
      width: 100px;
      height: 100px;
      left: -25px;
      bottom: -70px;
    }
  }

  .sidemenu {
    position: fixed;
    right: 20px;
    top: calc(50% - 100px);
    width: 250px;
    padding: 20px;
    background: #eef5e8;
    border-radius: 10px;

    &--is-hidden {
      opacity: 0;
      transform: translateY(20px);
      pointer-events: none;
      transition: opacity 0.5s ease;
    }

    &--display {
      opacity: 1;
      transition: opacity 0.5s ease;
    }

    @include max-width(lg) {
      display: none;
    }

    &__list {
      margin-top: 20px;

      .sidemenu-item {
        margin-bottom: 10px;

        .sidemenulink {
          display: inline-block;
          position: relative;
          font-weight: bold;
          width: 100%;

          &::after {
            content: "";
            width: 13px;
            height: 13px;
            border: 0;
            border-top: 2px solid #004D40;
            border-right: 2px solid #004D40;
            transform: rotate(135deg);
            position: absolute;
            top: 0;
            right: 20px;
            bottom: 5px;
            margin: auto;
          }

          &:hover {
            color: #E95B10;

            &::after {
              border-top: 2px solid #E95B10;
              border-right: 2px solid #E95B10;
            }
          }
        }

        .cv-btn {
          width: 100%;
          margin-top: 30px;

          &::before {
            content: none;
          }
        }
      }
    }
  }
}

//ストーリー
.fifth {
  background: #004D40;

  .fifth-wrap {
    padding-top: 50px;
    padding-bottom: 50px;

    .storyimg {
      margin: 20px 0;
    }
  }
}

//ポイント
.second {
  overflow: hidden;

  .second-list {
    border-bottom: 5px solid #004D40;

    &__item {
      padding: 50px 20px;
      background: #FFFFE8;
      border-top: 5px solid #004D40;

      .pointh3 {
        position: relative;
        margin-bottom: 30px;

        &::after {
          position: absolute;
          content: "";
          background: url(/static/renew3_img/yagiprime_lp20250220/shorange.png) no-repeat;
          background-position: center;
          background-size: contain;
          width: 100px;
          height: 100px;
          right: -15px;
          bottom: -40px;
          z-index: 1;
        }

        .pointimg {
          position: relative;
          width: 125px;
          height: auto;
          margin-bottom: 10px;
          z-index: 5;

          &--txt {
            height: 60px;
            width: auto;
          }
        }

        .pointh3img {
          position: relative;
          z-index: 5;
        }

      }

      .pointhgr3 {
        &::after {
          background: url(/static/renew3_img/yagiprime_lp20250220/shgreen.png) no-repeat;
          background-position: center;
          background-size: contain;
        }
      }

      .pointloth3 {
        &::after {
          bottom: -30px;
        }
      }

      .subpoint-list {
        font-weight: bold;
        font-size: 18px;
        line-height: 1.6;
        margin: 0 auto 30px;

        .subpoint-item {
          position: relative;
          margin-left: 60px;

          &:first-child {
            margin-bottom: 10px;
          }

          &::before {
            position: absolute;
            content: url(/static/renew3_img/yagiprime_lp20250220/checkimg.svg);
            width: 40px;
            height: 40px;
            top: calc(50% - 20px);
            left: -50px;
          }

        }

        .subpoint-gritem {
          &::before {
            content: url(/static/renew3_img/yagiprime_lp20250220/checkimggreen.svg);
          }
        }
      }

      .pointlot_lead {
        font-size: 18px;
        font-weight: bold;
        text-align: center;
        margin-bottom: 30px;
      }

      .servicelist {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        margin-bottom: 20px;

        .serviceitem {
          width: calc(100% / 3 - 10px);
          margin-bottom: 10px;
        }
      }

      .imgblock {
        margin-bottom: -40px;

        .pointbgimg {
          width: 80%;
          border-radius: 20px;
          margin-bottom: 20px;
        }

        .pointlotbgimg {
          margin-bottom: 30px;
        }

        .yagiword {
          position: relative;
          width: 48%;
          top: -250px;
          right: -175px;
          transform: rotate(5deg);

          @include max-width(sm) {
            top: -280px;
          }
        }

        &--agent {
          margin-bottom: 0;

          .pointbgimg {
            width: 100%;
          }
        }
      }

      .point-txt {
        margin-bottom: 30px;
      }

      &--bk02 {
        background: #EFF8F8;
      }
    }
  }
}

//まとめ
.third {
  padding-top: 50px;
  padding-bottom: 50px;

  .thirdh3 {
    margin-bottom: 30px;
    text-align: center;
  }

  .third_img {
    display: block;
    margin: 0 auto 20px;
    border-radius: 20px;
  }

  .third_lead {
    font-size: 16px;
    font-weight: bold;
    text-align: center;
    margin-bottom: 10px;
  }

  .third_txt {
    margin-bottom: 20px;
  }

  .third_memo {
    font-size: 12px;
    text-align: center;
  }

  .forth-table {
    width: 100%;
    text-align: center;
    //margin-top: 50px;
    margin-bottom: 50px;

    td {
      padding: 10px 0;
      border: 1px solid #eef5e8;
      vertical-align: middle;
    }

    .f-table03 {
      font-weight: 700;
      background: #eef5e8;
      color: #004D40;
    }
  }

  .studentplan {
    margin-top: 50px;

    .thirdh3 {
      position: relative;
      margin-bottom: 30px;
      text-align: center;

      &::after {
        position: absolute;
        content: "";
        background: url(/static/renew3_img/yagiprime_lp20250220/shgreen.png) no-repeat;
        background-position: center;
        background-size: contain;
        width: 100px;
        height: 100px;
        right: -15px;
        bottom: -55px;
        z-index: 1;
      }

      .pointh3img {
        position: relative;
        z-index: 2;
      }
    }

    .subpoint-list {
      font-weight: bold;
      font-size: 18px;
      line-height: 1.6;
      margin: 0 auto 30px;

      .subpoint-item {
        position: relative;
        margin-left: 60px;
        margin-bottom: 10px;

        &::before {
          position: absolute;
          content: url(/static/renew3_img/yagiprime_lp20250220/checkimg.svg);
          width: 40px;
          height: 40px;
          top: calc(50% - 20px);
          left: -50px;
        }

        &:last-child {
          margin-bottom: none;
        }

        span {
          color: #E95B10;
        }
      }
    }

    .tableaddimg {
      margin: 20px 0;
    }
  }
}

//よくある質問
.forth {
  padding-bottom: 50px;

  .thirdh3 {
    margin-bottom: 30px;
    text-align: center;
  }

  .forth-faq {
    margin-bottom: 25px;

    &__list {
      background: #eef5e8;
      border-radius: 10px;
      padding: 20px;
      margin-bottom: 10px;

      &:last-child {
        margin-bottom: 0;
      }

      .question {
        font-weight: bold;
        font-size: 16px;
        margin-bottom: 10px;
      }

      .answer {
        .a-link {
          color: #E95B10;
        }
      }
    }
  }
}
</style>
